import { useAuth } from "@/provider/UserProvider";
import { getListKeySdk } from "@/services/sdk";
import { useEffect, useState } from "react";

const useFetch = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const { isLoginClient } = useAuth();

  const getData = async () => {
    try {
      const res = await getListKeySdk();
      if (res.data) setList(res.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (isLoginClient) getData()
    else setList([])
  }, [isLoginClient]);

  return { list, loading, getData }
}

export default useFetch;